import styled, { css } from 'styled-components';
import { layout } from '@prisjakt/ui-base';
import { AdLabel } from '../../styles';

type AdPlacementContainerProps = {
  isTakover?: boolean;
};

export const AdPlacementContainer = styled.div<AdPlacementContainerProps>`
  font-size: 0;
  margin: auto;
  text-align: center;
  position: relative;
  display: block;
  border: 1px solid ${p => p.theme.lines.secondary};
  box-sizing: content-box;
  max-height: none;

  ${p =>
    p.isTakover &&
    css`
      margin-top: 0;
      margin-left: 0;
      margin-right: 0;
      overflow: hidden;
      border: 0;
    `}

  ${AdLabel} {
    z-index: ${p => (p.isTakover ? 11 : 1)};
  }
`;

export const AdCogwheel = styled.div`
  position: absolute;
  z-index: 1;
  top: 0;
  right: 0;
  width: ${layout.measurements.spacing150};
`;
